import { mapValues, unary } from 'lodash'

import EnterBeds from './EnterBeds'
import EnterBaths from './EnterBaths'
import EnterSqFt from './EnterSqFt'
import EnterAdditionalUpdates from './EnterAdditionalUpdates'
import HomeFactsStepsContainer from './HomeFactsStepsContainer'

export default mapValues(
  {
    EnterBeds,
    EnterBaths,
    EnterSqFt,
    EnterAdditionalUpdates
  },
  unary(HomeFactsStepsContainer)
)
